import { k1Axios } from './axios';
import { DataResponse, User } from '../models';

export const me = async () => (await k1Axios.get<DataResponse<User>>('/auth/me')).data.data;
